export const constructStrRep = (obj) => {
  if (obj.str_representation) return obj.str_representation;
  if (obj.title) return obj.title;
  return "Internal Customer";
};
export const detailUrl = ({ id }) => {
  return `/internal-customers/detail/${id}`;
};
